import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import StageRepository from '@/shared/http/repositories/configuration/stage'
import ExpertRepository from '@/shared/http/repositories/configuration/expert'
import ExpertMixin from '@/store/module/expert/mixin.js'

import SinisterSearchData from '@/shared/models/regulation/auto/sinistersearchmodel.js'
import SLAForms from './sla-form'

export default {
  name: 'Distribution',
  mixins: [ ActionsForm, ExpertMixin ],
  data () {
    return {
      data: SinisterSearchData,
      form: SLAForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Datepicker
  },
  mounted () {
    this.getAllExpertByArea(process.env.AreaAutos)
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      // this.$refs.tableGrid.Clear(null)
      this.objList = []
    },
    onLoad () {
      this.onLoadAllInsurer()
      this.onLoadAllStage()
      this.onLoadAllExpert()
    },
    onLoadAllInsurer () {
      loading.push()
      this.form.insurance.options = []
      InsuranceRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.insurance.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllStage () {
      loading.push()
      this.form.stage.options = []
      StageRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.stage.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllExpert () {
      loading.push()
      this.form.expert.options = []
      this.form.expertID.options = []
      ExpertRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.expert.options = this.onResultSelect2(response)
          this.form.expertID.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getAllExpert () {
      var result = []
      if (Array.isArray(this.form.expert)) {
        result = this.form.expert.filter(x => x.status).map(e => {
          return { 'label': e.name, 'value': e.id }
        })
        this.form.expertID.options = result
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/reports/sla/sla.js